import React, {useState} from "react";
import { Box, Button, Column, Columns, Title } from "@allxsmith/bestax-bulma";
import useInput from "../../../../hooks/useInput";
import VehicleMakePicker from "../../../Vehicle/VehicleMakePicker";
import usePostVehicleModel from "../../../../hooks/usePostVehicleModel";


export default function NewVehicleModel({makes, makeObjects}){

    let [name, nameInput, setName] = useInput({
        type: "text",
        label: "Name"
    });
    let [mileageLimit, mileageLimitInput, setMileageLimit] = useInput({
        type: "number",
        label: "Mileage Limit"
    });

    let [make, setMake] = useState({id: 0})


    const clear = () =>{
        setName("");
        setMileageLimit(0);
        setMake({id: 0});
    }
    const [, postModel] = usePostVehicleModel({
        name: name,
        mileage_limit: mileageLimit,
        make: makeObjects[make.id]
    })
    const handleSubmit = () => {
        postModel().then(() => (
            clear()
        ))
    }

    return (
        <Box className="settings_type">
            <details>
                <summary><Title>Add Vehicle Model</Title></summary>
            <Columns isMultiline>
                {nameInput}
                {mileageLimitInput}
                <Column>
                    <VehicleMakePicker
                      makes={makes}
                      vehicle={{make: make}}
                      onChange={e => setMake({id: e.target.value})}
                    />
                </Column>
            </Columns>
            <Columns isMultiline>
              <Column>
                  <Button
                      color={"success"}
                      onClick={handleSubmit}
                      isFullWidth
                  >
                      Add +
                  </Button>
              </Column>
            </Columns>
            </details>
        </Box>
    );
}